import React from 'react';
import Spells from '../Spells/spells';

const SpellList = ({spell})=>{
    return(
        <div>
            <div className="cf">
                <div className="fl w-third tc pv5">
                    SPELL
                </div>
                <div className="fl w-third tc pv5">
                    TYPE
                </div>
                <div className="fl w-third tc pv5">
                    EFFECT
                </div>
            </div>
            <div className="potter__list">
                {
                    spell.map((user,i) =>{
                        return (
                            <Spells 
                            key={i}
                            spell={spell[i].spell}
                            type={spell[i].type}
                            effect = {spell[i].effect}
                            />
                        );
                    })
                }
            </div>
        </div>
    )
}

export default SpellList
